import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { parseDate } from '@internationalized/date';
import { selectDateRange, selectMaterialId } from '@pages/reporting-pages/deliveries-sku-district/store/selectors';
import { setDateRange, setMaterialId } from '@pages/reporting-pages/deliveries-sku-district/store/slice';
import { DateRangePicker } from 'components/date-picker/DateRangePicker';
import { TextField } from 'components/text-field/TextField';
import { DateRange } from '@project-types/DateRange';



const ParamsToolbar = () => {

	const dateRange = useSelector(selectDateRange);
	const materialId = useSelector(selectMaterialId);

	const dispatch = useDispatch();
	const updateDateRange = (dateRange: DateRange) => dispatch(setDateRange(dateRange));
	const updateMaterialId = (value: string | null) => dispatch(setMaterialId(value));


	return (
		<div className='reporting-params-toolbar'>
			
			<DateRangePicker
				label='Od - Do'
				isRequired={true}
				value={
					dateRange
					? { start: parseDate(dateRange.from), end: parseDate(dateRange.to) }
					: null
				}
				onChange={(rangeValue) => {
					if (rangeValue) {
						updateDateRange({
							from: rangeValue.start.toString(),
							to: rangeValue.end.toString(),
						});
					}
				}}
			/>

			<TextField
				label='ID materiálu'
				maxLength={25}
				value={materialId}
				isRequired={true}
				onChange={(value) => {
					if (!value || value.length === 0) {
						updateMaterialId(null);
					}
					updateMaterialId(value);
				}} />

		</div>
	)
};

export default memo(ParamsToolbar);